import React from "react";

export type TabType = "overview" | "engagement" | "collaboration";

export interface TabsNavigationProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const tabs: { value: TabType; label: string }[] = [
  { value: "overview", label: "Overview" },
  { value: "engagement", label: "Engagement" },
  { value: "collaboration", label: "Collaboration" },
];

export const TabsNavigation: React.FC<TabsNavigationProps> = ({ activeTab, setActiveTab }) => {
  return (
    <div className="mt-8 px-6">
      <div className="flex gap-8">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            type="button"
            onClick={() => setActiveTab(tab.value)}
            className={`pb-3 text-lg font-bold transition ${
              activeTab === tab.value
                ? "text-[#9333EA] border-b-2 border-[#9333EA]"
                : "text-black font-normal"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabsNavigation;
